import React from 'react';
import styled from 'styled-components';


const EsReqDvryInfoWaitBlock = styled.div``;

const EsReqDvryInfoWait = ({ detailInfo, rqst_date_format, dsrd_date_format, rqst_status }) => {

    const getAreaType = () => {
        if (detailInfo.userinfo.area_size === null ||
            detailInfo.userinfo.area_size * 1 === 0) {
            return '';
        } else {
            return (detailInfo.userinfo.area_type === '055202' ? "전용" : "공급");
        }
    }

    const getAreaInfo = () => {

        if (detailInfo.userinfo.area_size === null ||
            detailInfo.userinfo.area_size * 1 === 0) {
            return "-";
        } else {
            return (<span className="font-mont">{detailInfo.userinfo.area_size}</span>);
        }
    }

    const getQuestion = () => {
        // console.log("detailInfo.userinfo.es_question : " + detailInfo.userinfo.es_question)
        if (detailInfo.userinfo.es_question === null ||
            detailInfo.userinfo.es_question === '') {
            return '';
        } else {
            return (
                <tr>
                    <td className="gray border_bottom">문의 사항</td>
                    <td colSpan="3" className="border_bottom">
                        <p className="question-text">{detailInfo.userinfo.es_question}</p>
                    </td>
                </tr>
            )
        }
    }

    return (
        <EsReqDvryInfoWaitBlock>

            <div className="default-table margin_b-120">
                <h3 className="dt-title">배송 정보 및 추가 사항</h3>
                {
                    detailInfo === null ? null :

                        <table>
                            <colgroup>
                                <col width="180px;" />
                                <col width="410px;" />
                                <col width="180px;" />
                                <col width="410px;" />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="gray">배송 가능 일자</td>
                                    <td colSpan="3">
                                        <p className="margin_b-10">
                                            <span className="font-mont"><span>{dsrd_date_format}</span> </span>
                                        </p>
                                        <p className="ess_text">
                                            ※ 확정된 날짜가 아닙니다. 희망 배송일자이므로 업체와 상의후 확정 지으시길 바랍니다.
                                            </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="gray border_black">배송 지역</td>
                                    <td colSpan="3" className="border_black">
                                        <p>
                                            {detailInfo.userinfo.addr1} , {detailInfo.userinfo.addr2}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="gray">평수</td>
                                    <td>
                                        {getAreaType()} {getAreaInfo()}
                                    </td>
                                    <td className="gray">주거 형태</td>
                                    <td>
                                        {detailInfo.userinfo.code_nm === null ? '-' : detailInfo.userinfo.code_nm}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="gray border_bottom">설치 및 조립 요청 </td>
                                    <td colSpan="3" className="border_bottom">
                                        {detailInfo.userinfo.is_install_chrg ? '비용 확인해주세요.' : '-'}
                                    </td>
                                </tr>
                                {getQuestion()}

                            </tbody>
                        </table>
                }
            </div>


        </EsReqDvryInfoWaitBlock>
    );
};

export default EsReqDvryInfoWait;
